import {
    AppstoreOutlined,
    CreditCardFilled,
    ExclamationCircleFilled,
    FallOutlined,
    FileAddOutlined,
    FilePdfFilled,
    FileProtectOutlined,
    PauseCircleOutlined,
    PlusOutlined,
    ReloadOutlined,
    RiseOutlined,
    FilterOutlined,
    DownloadOutlined,
} from "@ant-design/icons";
import {
    Badge,
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Slider,
    Space,
    Spin,
    Switch,
    Table,
    Tabs,
    Tag,
} from "antd";
import { Footer } from "antd/es/layout/layout";
import ContratListTable from "../../components/tables/ContratListTable";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { rightsService } from "../../services/rightsService";
import axiosInstance from "../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../variables/constants";
import {
    frenchDate,
    frenchDateOnly,
    frenchDateSimple,
} from "../../variables/functions";
import AttestationMoto from "./components/docs/AttestationMoto";
import AttestationMotoToPrint from "./components/docs/AttestationMotoToPrint";
import DTRFFormat from "./components/docs/DTRFFormat";
import { displayNumbers } from "../../variables/numbersFunctions";
import { Calendar, Filter, X } from "lucide-react";
import { highlightMatch } from "../../variables/stringFunctions";
import { searchProduction } from "../../hooks/useSearch";
import { StatCard } from "../../components/statistics/StatCard";
import { COLORS } from "../../components/ui/colors";

const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";

const Production = () => {
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [membres, setMembres] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [numAttestationModal, setNumAttestationModal] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [numeroAttestations, setNumeroAttestations] = useState([]);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [modePaiement, setModePaiement] = useState("");
    const [contractsToPay, setContractsToPay] = useState([]);
    const [contractToPay, setContractToPay] = useState();
    const [modePaiementForm] = Form.useForm();
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [currentContractIndex, setCurrentContractIndex] = useState(0);
    const [count, setCount] = useState("");
    const [ecritures, setEcritures] = useState([]);
    const [loadingEcritures, setLoadingEcritures] = useState({});
    const [searchResults, setSearchResults] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonths, setSelectedMonths] = useState([]);
    const [showFilters, setShowFilters] = useState(false);
    const currentYear = new Date().getFullYear();
    const startYear = 2009;
    const ct = currentYear - startYear + 1; // Calculate the total number of years needed

    const years = Array.from({ length: ct }, (_, i) => startYear + i).reverse();
    const months = [
        { value: 1, label: 'Janvier' },
        { value: 2, label: 'Février' },
        { value: 3, label: 'Mars' },
        { value: 4, label: 'Avril' },
        { value: 5, label: 'Mai' },
        { value: 6, label: 'Juin' },
        { value: 7, label: 'Juillet' },
        { value: 8, label: 'Août' },
        { value: 9, label: 'Septembre' },
        { value: 10, label: 'Octobre' },
        { value: 11, label: 'Novembre' },
        { value: 12, label: 'Décembre' }
    ];

    const toggleMonth = (month) => {
        setSelectedMonths(prev =>
            prev.includes(month)
                ? prev.filter(m => m !== month)
                : [...prev, month]
        );
    };

    const clearFilters = () => {
        setSelectedYear(new Date().getFullYear());
        setSelectedMonths([]);
    };

    const hasActiveFilters = selectedYear !== new Date().getFullYear() || selectedMonths.length > 0;


    // État pour gérer l'onglet actif
    const [activeTab, setActiveTab] = useState("6");
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedCompagnies, setSelectedCompagnies] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, showSizeChanger: true });

    const columns = [
        {
            title: "Numero de police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Organisme",
            dataIndex: "organisme",
            key: "3",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Statut reg.",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_} style={{ fontWeight: 500, padding: '4px 12px' }}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="processing" key={_} style={{ fontWeight: 500, padding: '4px 12px' }}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Prime nette",
            dataIndex: "primeNette",
            key: "primeNette",
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
        },
        {
            title: "Prime TTC",
            dataIndex: "primeTotale",
            key: "primeTotale",
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <Space size="small">
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                        style={{
                            backgroundColor: '#1890ff',
                            borderColor: '#1890ff',
                            boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
                        }}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                </Space>
            ),
        },
    ];

    const printRef = useRef();

    const navigate = useNavigate();

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings;
        const [startDay, startMonth, startYear] = sDate.split("/");
        const [endDay, endMonth, endYear] = eDate.split("/");
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;
        console.table([startDate, endDate]);
        setSelectedDate([startDate, endDate]);
        setFilteredInfo({
            ...filteredInfo,
            startDate,
            endDate,
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                startDate,
                endDate,
            },
        });
    };

    const fetchData = async (params = {}) => {
        setLoadingContrats(true);
        try {
            const response = await axiosInstance.get("/api/contrat", {
                params: {
                    page: params.pagination.current - 1,
                    size: params.pagination.pageSize,
                    ...params.filters,
                    compagnie: params.filters?.compagnie?.join(','),
                    avenant: tabsDefinition[activeTab - 1].avenant
                },
            });
            const { content, totalElements } = response.data;

            let ctrs = [];
            content.forEach((contrat, key) => {
                ctrs.push({
                    key: contrat.codeId,
                    codeId: contrat.codeId,
                    id: key,
                    numeroPolice: contrat.numeroPoliceM
                        ? contrat.numeroPoliceM
                        : contrat.numeroPoliceP,
                    numeroPoliceP: contrat.numeroPoliceP,
                    souscripteur: contrat?.prenom
                        ? ` ${contrat?.nom} ${contrat?.prenom}`
                        : `${contrat?.nom}`,
                    organisme: contrat?.raisonSociale,
                    dateEffet: contrat?.dateEffet
                        ? `${frenchDate(contrat?.dateEffet)}`
                        : "",
                    dateEcheance: contrat?.dateEcheance
                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                        : "",
                    regle: contrat.reglements
                        ? contrat.reglements
                            ? "REGLE"
                            : "NON REGLE"
                        : "NON REGLE",
                    primeTotale: displayNumbers(contrat?.primeTotale),
                    taxes: displayNumbers(contrat?.primeTotale * 0.06 / 1.06),
                    primeNette: displayNumbers(contrat?.primeNetteFractionnee ? contrat?.primeNetteFractionnee : contrat?.primeNette),
                    accessoires: contrat?.primeNetteFractionnee ? `Inclus dans P.N.` : displayNumbers(contrat?.accessoires),
                    data: contrat,
                });
            });
            setData(ctrs);
            setPagination({
                ...params.pagination,
                total: totalElements,
            });
            setTotal(totalElements);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    const exportDataToExcel = async () => {
        if (selectedDate) {
            setLoadingContrats(true);
            const startDate = selectedDate[0];
            const endDate = selectedDate[1];
            const response = await axiosInstance.get("/api/contrat/all", {
                params: {
                    startDate,
                    endDate,
                    compagnie: selectedCompagnies?.join(','),
                },
            });
            console.log("ok: ", response?.data);
            generateExcelFileFromArray(response?.data);
            setLoadingContrats(false);
        } else {
            toast("Veuillez sélectionner une période!");
        }
    }

    useEffect(() => {
        if (selectedDate || selectedCompagnies) {
            if (selectedDate) {
                const startDate = selectedDate[0];
                const endDate = selectedDate[1];
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        startDate,
                        endDate,
                        compagnie: selectedCompagnies
                    },
                });
            } else {
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        compagnie: selectedCompagnies
                    },
                });
            }

        } else {
            fetchData({
                pagination,
                filteredInfo,
            });
        }

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                let membs = [];
                res.data.forEach((memb, index) => {
                    membs.push({
                        key: index,
                        text: memb.raisonSociale,
                        value: memb.code,
                        data: memb,
                    });
                });
                membs.push({
                    key: "DTRF",
                    text: "DTRF",
                    value: "DTRF",
                });
                membs.push({
                    key: "DTRF-Lome",
                    text: "DTRF-LOME",
                    value: "LOME",
                });
                membs.push({
                    key: "DTRF-Kpalime",
                    text: "DTRF-KPALIME",
                    value: "KPALIME",
                });
                membs.push({
                    key: "DTRF-Atakpame",
                    text: "DTRF-ATAKPAME",
                    value: "ATAKPAME",
                });
                membs.push({
                    key: "DTRF-Sokode",
                    text: "DTRF-SOKODE",
                    value: "SOKODE",
                });
                membs.push({
                    key: "DTRF-Kara",
                    text: "DTRF-KARA",
                    value: "KARA",
                });
                membs.push({
                    key: "DTRF-Dapaong",
                    text: "DTRF-DAPAONG",
                    value: "DAPAONG",
                });
                membs.push({
                    key: "STCA",
                    text: "STCA",
                    value: "STCA",
                });
                setMembres(membs);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/contrat/count`)
            .then((res) => {
                setCount(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage, pageSize, selectedDate, activeTab]);

    const filteringOnCompanies = (companies) => {
        setSelectedCompagnies(companies);
        setFilteredInfo({
            ...filteredInfo,
            compagnie: companies
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                compagnie: companies
            },
        });
    };

    const attestationRefs = useRef(selectedContrats.map(() => React.createRef()));
    const printedAttestationRefs = useRef(
        selectedContrats.map(() => React.createRef()),
    );

    const MyFooter = () => {
        let ctrt = selectedRows.find((ctr) => ctr.regle === "NON REGLE");
        let rCtrts = selectedRows.filter((ctr) => ctr.regle === "REGLE");
        let nrCtrts = selectedRows.filter((ctr) => ctr.regle === "NON REGLE");
        return (
            <div class="row" style={{ padding: '16px 0' }}>
                {ctrt ? (
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                encaisserContrats(nrCtrts);
                            }}
                            type="primary"
                            icon={<CreditCardFilled />}
                            size="large"
                            style={{
                                backgroundColor: '#52c41a',
                                borderColor: '#52c41a',
                                fontWeight: 500,
                                boxShadow: '0 4px 12px rgba(82, 196, 26, 0.3)'
                            }}
                            title="Encaissement"
                        >
                            Encaisser
                        </Button>
                    </div>
                ) : (
                    <>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportToPdfs(rCtrts);
                                }}
                                type="primary"
                                icon={<FilePdfFilled />}
                                size="large"
                                style={{
                                    backgroundColor: '#242166',
                                    borderColor: '#242166',
                                    fontWeight: 500,
                                    boxShadow: '0 4px 12px rgba(36, 33, 102, 0.3)'
                                }}
                            >
                                Imprimer C.P.
                            </Button>
                        </div>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportAttestations(rCtrts);
                                }}
                                type="primary"
                                icon={<FileProtectOutlined />}
                                size="large"
                                style={{
                                    backgroundColor: '#1890ff',
                                    borderColor: '#1890ff',
                                    fontWeight: 500,
                                    boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                                }}
                            >
                                Imprimer Attestation
                            </Button>
                        </div>
                    </>
                )}
            </div>
        );
    };


    const encaisserContrats = (cts) => {
        setModalModePaiement(true);
        setContractsToPay(cts);
    };

    const encaisserContrat = (id) => {
        setModalModePaiement(true);
        setContractToPay(id);
    };

    const alertReglement = (contractToPay) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ce contrat?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementContrat(contractToPay);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementContrat = (id) => {
        if (modePaiement === "ESPECES") {
            axiosInstance
                .get(
                    `/api/reglement/especes/contrat/codeId/${id}/${LOGGED_USER.codeId}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Reglement effectué avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .get(
                    `/api/reglement/contrat/codeId/${id}/${LOGGED_USER.codeId}/${modePaiement}/${numeroPaiement}/${banque}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Règlement effectué avec succès!");
                    res.data = null;
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const alertReglements = (cts) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ces contrats?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementsContrats(cts);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementsContrats = (contrats) => {
        var allContrats = [];
        contrats.forEach((ctrt) => {
            allContrats.push(ctrt.data);
        });
        if (modePaiement === "ESPECES") {
            axiosInstance
                .post(`/api/reglement/especes/contrats`, JSON.stringify(allContrats))
                .then((res) => {
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .post(
                    `/api/reglement/else/${modePaiement}/${numeroPaiement}/${banque}`,
                    JSON.stringify(allContrats),
                )
                .then((res) => {
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const exportAttestations = (contrats) => {
        setNumAttestationModal(true);
        setSelectedContrats(contrats);
    };

    const attestationPrinting = () => {
        selectedContrats.forEach((aContrat, index) => {
            exportAttestationToPdf();
        });
    };

    const exportAttestationToPdf = useReactToPrint({
        content: () => attestationRefs.current[currentContractIndex]?.current,
        onBeforeGetContent: () => setPrintingAttestation(false),
        onAfterPrint: () => {
            setCurrentContractIndex((prevIndex) => prevIndex + 1);
        },
    });

    useEffect(() => {
        if (currentContractIndex < selectedContrats.length) {
            exportAttestationToPdf();
        } else {
            setCurrentContractIndex(0);
        }
    }, [currentContractIndex]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const exportToPdfs = (contrats) => {
        setSelectedContrats(contrats);
        setHidden(true);
        setTimeout(() => {
            handlePrint();
            contrats.forEach((ctrt) => {
                axiosInstance
                    .get(
                        `/api/contrat/impression/codeId/${ctrt.codeId}/${LOGGED_USER.codeId}`,
                    )
                    .then((res) => {
                        console.log("OK");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        }, [500]);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const pbStyles = {
        pageBreak: {
            pageBreakBefore: "always",
        },
    };


    const generateExcelFileFromArray = (array, fileName = "ListingPolices") => {
        const headers = [
            'N° Police', 'Immatriculation', 'Assuré',
            'Date effet', 'Date échéance', 'Puissance/Volume', 'Prime nette', 'Accessoires',
            'Taxes', 'Prime TTC', 'Numero paiement', 'Reference',
            'Prime à reporter', 'Apporteur', 'Concessionnaire'
        ];

        const formatDate = (date) => date ? frenchDateOnly(date) : "";
        const floorOrEmpty = (val) => val != null ? Math.floor(val) : "";
        const getEngin = (item) => item?.engins?.[0];

        const resolvers = {
            'N° Police': (item) => item?.numeroPoliceP ?? "",
            'Immatriculation': (item) => getEngin(item)?.immatriculation ?? "",
            'Assuré': (item) => [item?.souscripteur?.nom, item?.souscripteur?.prenom].filter(Boolean).join(" "),
            'Date effet': (item) => formatDate(item?.dateEffet),
            'Date échéance': (item) => formatDate(item?.dateEcheance),
            'Puissance/Volume': (item) => getEngin(item)?.puissance ?? getEngin(item)?.volume ?? "",
            'Prime nette': (item) => floorOrEmpty(item?.primeNette),
            'Accessoires': (item) => floorOrEmpty(item?.accessoires),
            'Taxes': (item) => floorOrEmpty(item?.primeTotale * 0.06 / 1.06),
            'Prime TTC': (item) => floorOrEmpty(item?.primeTotale),
            'Numero paiement': (item) => item?.numeroQuittance ?? "",
            'Reference': (item) => item?.referencePaiement ?? "",
            'Prime à reporter': (item) => floorOrEmpty(item?.prec),
            'Apporteur': (item) => item?.intermediaireNom ? `${item.intermediaireNom} - ${item.intermediaireCode}` : "",
            'Concessionnaire': (item) => item?.concessionnaire ?? "",
        };

        const mappedData = array.map(item =>
            Object.fromEntries(headers.map(header => [header, resolvers[header](item)]))
        );

        const worksheet = XLSX.utils.json_to_sheet(mappedData, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };

    const getEcritures = async (numeroPolice) => {
        return await axiosInstance
            .get(`/api/details-ecriture/ecriture/numeroPolice/${numeroPolice}`)
            .then((res) => {
                setEcritures(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    // Définition des onglets avec badges de comptage
    const tabsDefinition = [
        {
            key: "1",
            label: (
                <span>
                    <FileAddOutlined /> Affaires nouvelles
                    <Badge count={count?.avenantANCount} style={{ marginLeft: 8, backgroundColor: '#52c41a' }} />
                </span>
            ),
            avenant: "AN",
        },
        {
            key: "2",
            label: (
                <span>
                    <ReloadOutlined /> Renouvellements
                    <Badge count={count?.avenantRNCount} style={{ marginLeft: 8, backgroundColor: '#1890ff' }} />
                </span>
            ),
            avenant: "RN",
        },
        {
            key: "3",
            label: (
                <span>
                    <RiseOutlined /> Avenants positifs
                    <Badge count={count.primePositiveCount} style={{ marginLeft: 8, backgroundColor: '#52c41a' }} />
                </span>
            ),
            avenant: "P",
        },
        {
            key: "4",
            label: (
                <span>
                    <FallOutlined /> Avenants négatifs
                    <Badge count={count.primeNegativeCount} style={{ marginLeft: 8, backgroundColor: '#ff4d4f' }} />
                </span>
            ),
            avenant: "N",
        },
        {
            key: "5",
            label: (
                <span>
                    <PauseCircleOutlined /> Suspensions
                    <Badge count={count.avenantSPCount} style={{ marginLeft: 8, backgroundColor: '#faad14' }} />
                </span>
            ),
            avenant: "SP",
        },
        {
            key: "6",
            label: (
                <span>
                    <AppstoreOutlined /> Tous les contrats
                    <Badge count={count.totalContrats} style={{ marginLeft: 8, backgroundColor: '#242166' }} />
                </span>
            ),
            avenant: null,
        },
    ];

    const applyFilters = () => {
        setShowFilters(false);
        // Ici vous pouvez ajouter la logique pour appliquer les filtres
        console.log('Filtres appliqués:', { selectedYear, selectedMonths });
    };

    const renderSearchResults = (results) => {
        if (results.length === 0) {
            return <p>Aucun contrat trouvé.</p>;
        } else {
            return <div className="px-3 py-2">
                {results
                    .map((item, index) => (
                        <div
                            key={index}
                            onClick={() =>
                                navigate(`/details-contrat/${item.codeId}`)
                            }
                            className="dropdown-item d-flex align-items-center gap-2 py-1"
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="text-truncate">
                                {[
                                    item?.numeroPoliceP,
                                    item?.numeroPoliceM ? `(${item?.numeroPoliceM})` : '',
                                    frenchDate(item?.dateEffet),
                                    item?.nom,
                                    item?.prenom || '',
                                    item?.immatriculation,
                                ].map((text, i) => (
                                    <React.Fragment key={i}>
                                        {i > 0 && ' - '}
                                        {highlightMatch(text?.toString(), searchValue)}
                                    </React.Fragment>
                                ))}
                            </span>
                        </div>
                    ))}
            </div>
        }
    }

    useEffect(() => {
        if (searchValue && searchValue?.length > 2) {
            searchProduction(searchValue).then((res) => {
                setSearchResults(res.data.content);
            }).catch((err) => {
                console.log(err);
            });
        }
    }, [searchValue]);


    return (
        <div class="layout-wrapper layout-content-navbar">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                <div class="layout-page">
                    <NavBar
                        filteredResults={searchResults}
                        setFilteredResults={setSearchResults}
                        renderSearchResults={renderSearchResults}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />

                    <div class="content-wrapper" style={{ backgroundColor: '#f5f7fa' }}>
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <div style={{ display: 'flex', justifyContent: 'end' }}>
                                <button
                                    onClick={() => setShowFilters(true)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'end',
                                        gap: '8px',
                                        padding: '6px 12px',
                                        backgroundColor: hasActiveFilters ? '#8b5cf6' : '#242166',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s',
                                        position: 'relative'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = hasActiveFilters ? '#7c3aed' : '#1d4ed8'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = hasActiveFilters ? '#8b5cf6' : '#2563eb'}
                                >
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres
                                    {hasActiveFilters && (
                                        <span style={{
                                            position: 'absolute',
                                            top: '-6px',
                                            right: '-6px',
                                            width: '20px',
                                            height: '20px',
                                            backgroundColor: '#ef4444',
                                            color: 'white',
                                            borderRadius: '50%',
                                            fontSize: '11px',
                                            fontWeight: 'bold',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '2px solid white'
                                        }}>
                                            {selectedMonths.length || '!'}
                                        </span>
                                    )}
                                </button>
                            </div>

                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats validés"
                                        subtitle="Nbre total actifs / Nbre total validés"
                                        value={`${count?.activeCount ? displayNumbers(count?.activeCount) : 0} / ${count?.valideCount ? displayNumbers(count?.valideCount) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(count?.annuleCount || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(count?.enPropositionCount || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>

                            {/* Boutons d'action */}
                            <div class="row" style={{ marginBottom: '24px' }}>
                                <div class="col-sm-4">
                                    {rightsService("HCO022") ||
                                        rightsService("HCO005") ||
                                        rightsService("HCO019") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            onClick={() => navigate("/ajouter-contrat-new")}
                                            style={{
                                                backgroundColor: '#242166',
                                                borderColor: '#242166',
                                                fontWeight: 500,
                                                height: '44px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 12px rgba(36, 33, 102, 0.3)'
                                            }}
                                        >
                                            Nouveau contrat
                                        </Button>
                                    ) : null}
                                </div>
                                <div class="col-sm-4">
                                    {rightsService("HLA078") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            onClick={() => navigate("/ancien-contrat-gum")}
                                            style={{
                                                backgroundColor: '#595959',
                                                borderColor: '#595959',
                                                fontWeight: 500,
                                                height: '44px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 12px rgba(89, 89, 89, 0.3)'
                                            }}
                                        >
                                            Ajouter Ancien contrat GUM
                                        </Button>
                                    ) : null}
                                </div>
                            </div>

                            {/* Card principale avec filtres */}
                            <div class="card" style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                            }}>
                                <div class="container">
                                    <div class="card" style={{
                                        marginTop: '24px',
                                        borderRadius: '8px',
                                        backgroundColor: '#fafbfc',
                                        border: '1px solid #e8e8e8'
                                    }}>
                                        <div class="card-body">
                                            <div class="row align-items-center">
                                                <div class="col-12 col-md-4 mb-3 mb-md-0">
                                                    <Space align="center">
                                                        <span style={{ fontWeight: 500, color: '#595959' }}>Mode sélection:</span>
                                                        <Switch
                                                            checked={selecting}
                                                            onChange={setSelecting}
                                                            style={{
                                                                backgroundColor: selecting ? '#242166' : undefined
                                                            }}
                                                        />
                                                    </Space>
                                                </div>
                                                <div class="col-12 col-md-4 mb-3 mb-md-0">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        onChange={handleDateChange}
                                                        placeholder={["Date début", "Date fin"]}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: '6px',
                                                            borderColor: '#d9d9d9'
                                                        }}
                                                        suffixIcon={<FilterOutlined style={{ color: '#242166' }} />}
                                                    />
                                                </div>
                                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && (LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null) ?
                                                    <div class="col-12 col-md-4">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Filtrer par compagnie"
                                                            onChange={filteringOnCompanies}
                                                            options={membres.map((memb) => (
                                                                {
                                                                    label: memb.text,
                                                                    value: memb.value,
                                                                    key: memb.value
                                                                }
                                                            ))}
                                                            style={{ width: "100%" }}
                                                            suffixIcon={<FilterOutlined style={{ color: '#242166' }} />}
                                                        />
                                                    </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Onglets avec tableau */}
                                <Card
                                    className="main-card-pro"
                                    bordered={false}
                                    style={{ marginTop: '24px' }}
                                >
                                    <Tabs
                                        activeKey={activeTab}
                                        onChange={setActiveTab}
                                        className="custom-tabs-pro"
                                        size="large"
                                        items={tabsDefinition.map(({ key, label }) => ({
                                            key,
                                            label,
                                            children: (
                                                <div className="tab-content-wrapper-pro">
                                                    <ContratListTable
                                                        columns={columns}
                                                        data={data}
                                                        loading={loadingContrats}
                                                        pagination={pagination}
                                                        onChange={handleChange}
                                                        selecting={selecting}
                                                        rowSelection={rowSelection}
                                                        ecritures={ecritures}
                                                        loadingEcritures={loadingEcritures}
                                                        onExpand={(expanded, record) => {
                                                            if (expanded) {
                                                                const police = record.numeroPoliceP;
                                                                setLoadingEcritures(prev => ({ ...prev, [police]: true }));
                                                                getEcritures(police).finally(() => {
                                                                    setLoadingEcritures(prev => ({ ...prev, [police]: false }));
                                                                });
                                                            }
                                                        }}
                                                        footer={() => selecting ? <MyFooter /> : null}
                                                    />
                                                </div>
                                            ),
                                        }))}
                                        style={{ marginBottom: 16 }}
                                    />
                                </Card>
                            </div>

                            <div class="card" id="myContrat" ref={printRef}>
                                {selecting &&
                                    hidden &&
                                    selectedContrats.map((row, index) => (
                                        <DTRFFormat contrat={row.data} key={index} />
                                    ))}
                            </div>
                        </div>

                        {/* Modal des filtres */}
                        {showFilters && (
                            <>
                                {/* Overlay */}
                                <div
                                    onClick={() => setShowFilters(false)}
                                    style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                        zIndex: 9998,
                                        animation: 'fadeIn 0.2s ease'
                                    }}
                                />

                                {/* Modal */}
                                <div style={{
                                    position: 'fixed',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    borderRadius: '16px',
                                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                                    zIndex: 9999,
                                    width: '90%',
                                    maxWidth: '600px',
                                    maxHeight: '90vh',
                                    overflow: 'auto',
                                    animation: 'slideIn 0.3s ease'
                                }}>
                                    {/* Header modal */}
                                    <div style={{
                                        padding: '24px',
                                        borderBottom: '1px solid #e5e7eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: 'white',
                                        borderRadius: '16px 16px 0 0',
                                        zIndex: 1
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                            <div style={{
                                                padding: '8px',
                                                backgroundColor: '#eff6ff',
                                                borderRadius: '8px'
                                            }}>
                                                <Filter style={{ width: '20px', height: '20px', color: '#2563eb' }} />
                                            </div>
                                            <div>
                                                <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', margin: 0 }}>
                                                    Filtrer les sinistres
                                                </h3>
                                                <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
                                                    Sélectionnez la période souhaitée
                                                </p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => setShowFilters(false)}
                                            style={{
                                                padding: '8px',
                                                backgroundColor: '#f3f4f6',
                                                border: 'none',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                                            onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                        >
                                            <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                                        </button>
                                    </div>

                                    {/* Body modal */}
                                    <div style={{ padding: '24px' }}>
                                        {/* Sélection de l'année */}
                                        <div style={{ marginBottom: '24px' }}>
                                            <label style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                marginBottom: '12px'
                                            }}>
                                                <Calendar style={{ width: '16px', height: '16px' }} />
                                                Exercice (Année)
                                            </label>
                                            <select
                                                value={selectedYear}
                                                onChange={(e) => setSelectedYear(Number(e.target.value))}
                                                style={{
                                                    width: '100%',
                                                    padding: '12px',
                                                    border: '2px solid #e5e7eb',
                                                    borderRadius: '10px',
                                                    fontSize: '14px',
                                                    backgroundColor: 'white',
                                                    cursor: 'pointer',
                                                    transition: 'border-color 0.2s'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#2563eb'}
                                                onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                            >
                                                {years.map(year => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Sélection des mois */}
                                        <div>
                                            <label style={{
                                                display: 'block',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                color: '#374151',
                                                marginBottom: '12px'
                                            }}>
                                                Mois (sélection multiple)
                                            </label>
                                            <div style={{
                                                display: 'grid',
                                                gridTemplateColumns: 'repeat(3, 1fr)',
                                                gap: '10px'
                                            }}>
                                                {months.map(month => (
                                                    <button
                                                        key={month.value}
                                                        onClick={() => toggleMonth(month.value)}
                                                        style={{
                                                            padding: '12px',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                            borderRadius: '10px',
                                                            border: selectedMonths.includes(month.value) ? 'none' : '2px solid #e5e7eb',
                                                            backgroundColor: selectedMonths.includes(month.value) ? '#2563eb' : 'white',
                                                            color: selectedMonths.includes(month.value) ? 'white' : '#374151',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.2s'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!selectedMonths.includes(month.value)) {
                                                                e.target.style.backgroundColor = '#f9fafb';
                                                                e.target.style.borderColor = '#2563eb';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (!selectedMonths.includes(month.value)) {
                                                                e.target.style.backgroundColor = 'white';
                                                                e.target.style.borderColor = '#e5e7eb';
                                                            }
                                                        }}
                                                    >
                                                        {month.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Récapitulatif */}
                                        {hasActiveFilters && (
                                            <div style={{
                                                marginTop: '20px',
                                                padding: '16px',
                                                backgroundColor: '#eff6ff',
                                                borderRadius: '10px',
                                                border: '1px solid #bfdbfe'
                                            }}>
                                                <p style={{
                                                    fontSize: '13px',
                                                    color: '#1e40af',
                                                    margin: 0,
                                                    fontWeight: '500'
                                                }}>
                                                    📊 Filtres actifs : Année {selectedYear}
                                                    {selectedMonths.length > 0 && ` • ${selectedMonths.length} mois sélectionné(s)`}
                                                </p>
                                            </div>
                                        )}
                                    </div>

                                    {/* Footer modal */}
                                    <div style={{
                                        padding: '20px 24px',
                                        borderTop: '1px solid #e5e7eb',
                                        display: 'flex',
                                        gap: '12px',
                                        justifyContent: 'flex-end',
                                        position: 'sticky',
                                        bottom: 0,
                                        backgroundColor: 'white',
                                        borderRadius: '0 0 16px 16px'
                                    }}>
                                        <button
                                            onClick={clearFilters}
                                            style={{
                                                padding: '10px 20px',
                                                backgroundColor: 'white',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: '#374151',
                                                transition: 'all 0.2s'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.backgroundColor = '#f9fafb';
                                                e.target.style.borderColor = '#d1d5db';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.backgroundColor = 'white';
                                                e.target.style.borderColor = '#e5e7eb';
                                            }}
                                        >
                                            Réinitialiser
                                        </button>
                                        <button
                                            onClick={applyFilters}
                                            style={{
                                                padding: '10px 24px',
                                                backgroundColor: '#2563eb',
                                                border: 'none',
                                                borderRadius: '8px',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: 'white',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                                            onMouseLeave={(e) => e.target.style.backgroundColor = '#2563eb'}
                                        >
                                            Appliquer les filtres
                                        </button>
                                    </div>
                                </div>

                                <style>{`
                                            @keyframes fadeIn {
                                            from { opacity: 0; }
                                            to { opacity: 1; }
                                            }
                                            @keyframes slideIn {
                                            from {
                                                opacity: 0;
                                                transform: translate(-50%, -48%) scale(0.96);
                                            }
                                            to {
                                                opacity: 1;
                                                transform: translate(-50%, -50%) scale(1);
                                            }
                                            }
                                        `}</style>
                            </>
                        )}

                        {/* Modal Mode de paiement */}
                        <Modal
                            title={<span style={{ color: '#242166', fontSize: '18px', fontWeight: 600 }}>Mode de paiement</span>}
                            centered
                            open={modalModePaiement}
                            onOk={() => {
                                selecting
                                    ? alertReglements(contractsToPay)
                                    : alertReglement(contractToPay);
                            }}
                            onCancel={() => {
                                setModalModePaiement(false);
                            }}
                            okText="Valider"
                            cancelText="Annuler"
                            okButtonProps={{
                                style: {
                                    backgroundColor: '#242166',
                                    borderColor: '#242166',
                                    fontWeight: 500
                                }
                            }}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12}>
                                    <Form
                                        form={modePaiementForm}
                                        layout="vertical"
                                        name="userForm"
                                    >
                                        <Form.Item
                                            name="modePaiement"
                                            label={<span style={{ fontWeight: 500 }}>Mode de paiement</span>}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Veuillez sélectionner un mode de paiement'
                                                },
                                            ]}
                                        >
                                            <Select
                                                onChange={(value) => {
                                                    setModePaiement(value);
                                                }}
                                                placeholder="Sélectionnez votre mode de paiement"
                                                size="large"
                                            >
                                                <Option value="ESPECES">💵 ESPECES</Option>
                                                <Option value="BANQUE">🏦 BANQUE (Chèque)</Option>
                                                <Option value="MOBILE_MONEY">📱 TMONEY / FLOOZ</Option>
                                            </Select>
                                        </Form.Item>
                                        {modePaiement === "BANQUE" ||
                                            modePaiement === "MOBILE_MONEY" ? (
                                            <Form.Item
                                                name="numeroPaiement"
                                                label={
                                                    <span style={{ fontWeight: 500 }}>
                                                        {modePaiement === "BANQUE"
                                                            ? "Numéro de chèque"
                                                            : modePaiement === "MOBILE_MONEY"
                                                                ? "Numéro FLOOZ / TMONEY"
                                                                : ""}
                                                    </span>
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Veuillez renseigner le champ!",
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={
                                                        modePaiement === "BANQUE"
                                                            ? "Le numéro de chèque"
                                                            : modePaiement === "MOBILE_MONEY"
                                                                ? "Le numéro de téléphone MOOV (FLOOZ) / TOGOCOM (TMONEY)"
                                                                : ""
                                                    }
                                                    onChange={(value) => {
                                                        setNumeroPaiement(value.target.value);
                                                    }}
                                                    size="large"
                                                />
                                            </Form.Item>
                                        ) : null}
                                        {modePaiement === "BANQUE" ? (
                                            <Form.Item
                                                name="banque"
                                                label={<span style={{ fontWeight: 500 }}>Banque</span>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Veuillez sélectionner une banque'
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    onChange={(value) => {
                                                        setBanque(value);
                                                    }}
                                                    placeholder="Sélectionnez la banque"
                                                    size="large"
                                                >
                                                    {banques.map((b) => (
                                                        <Option
                                                            key={b.parametreId}
                                                            value={b.libelleParametre}
                                                        >
                                                            {b.libelleParametre}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        ) : null}
                                    </Form>
                                </div>
                            </div>
                        </Modal>

                        {/* Modal Attestation */}
                        <Modal
                            title={<span style={{ color: '#242166', fontSize: '18px', fontWeight: 600 }}>Attestations à imprimer</span>}
                            centered
                            open={numAttestationModal}
                            onOk={() => {
                                setNumAttestationModal(false);
                            }}
                            onCancel={() => {
                                setNumAttestationModal(false);
                            }}
                            width={1200}
                            zIndex={2000}
                            footer={[
                                <Button
                                    key="back"
                                    onClick={() => setNumAttestationModal(false)}
                                    size="large"
                                >
                                    Fermer
                                </Button>,
                                <Button
                                    key="print"
                                    onClick={() => {
                                        attestationPrinting();
                                    }}
                                    type="primary"
                                    icon={<FilePdfFilled />}
                                    size="large"
                                    style={{
                                        backgroundColor: '#52c41a',
                                        borderColor: '#52c41a',
                                        fontWeight: 500
                                    }}
                                >
                                    Imprimer
                                </Button>
                            ]}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12}>
                                    {selectedContrats.map((row, index) => (
                                        <div key={index}>
                                            <div>
                                                <AttestationMoto
                                                    ref={attestationRefs.current[index]}
                                                    contrat={row.data}
                                                    printing={
                                                        printingAttestation &&
                                                        currentContractIndex === index
                                                    }
                                                />
                                                <div style={{ display: "none" }}>
                                                    <AttestationMotoToPrint
                                                        ref={printedAttestationRefs.current[index]}
                                                        contrat={row.data}
                                                    />
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                            <div style={pbStyles.pageBreak} className="pageBreak">
                                                <hr />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{
                                backgroundColor: '#fafafa',
                                padding: '20px',
                                borderRadius: '8px',
                                marginTop: '20px'
                            }}>
                                <p style={{
                                    fontWeight: 500,
                                    color: '#242166',
                                    marginBottom: '16px'
                                }}>
                                    Veuillez préciser les numéros d'attestations à imprimer
                                </p>
                                <Slider
                                    range
                                    className="slider-main-div"
                                    min={10000}
                                    max={100000}
                                    onChange={(v) => {
                                        setNumeroAttestations(v);
                                    }}
                                    defaultValue={[10000, 100000]}
                                    value={numeroAttestations}
                                    trackStyle={[{ backgroundColor: '#242166' }]}
                                    handleStyle={[
                                        { borderColor: '#242166' },
                                        { borderColor: '#242166' }
                                    ]}
                                />
                            </div>
                        </Modal>

                        <Footer />
                        <div class="content-backdrop fade"></div>
                    </div>
                </div>
            </div>

            <div class="layout-overlay layout-menu-toggle"></div>
            {rightsService("HCO020") ? (
                <Spin spinning={loadingContrats}>
                    <div class="buy-now">
                        <button
                            onClick={() => exportDataToExcel()}
                            class="btn btn-secondary btn-buy-now"
                            style={{
                                backgroundColor: '#242166',
                                borderColor: '#242166',
                                fontWeight: 500,
                                fontSize: '15px',
                                padding: '9px 24px',
                                borderRadius: '10px',
                                boxShadow: '0 6px 20px rgba(36, 33, 102, 0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <DownloadOutlined style={{ fontSize: '18px' }} />
                            Exporter
                        </button>
                    </div>
                </Spin>
            ) : null}
            <div class="drag-target"></div>
        </div>
    );
};

export default Production;